export const contactsData = {
    email: 'kamosmbatyan0729@gmail.com',
    phone: '+37498568009',
    address: 'Belgrade, Serbia',

    sheetAPI: ''
}